// extracted by mini-css-extract-plugin
module.exports = {"RV-K":"NA_RV-K__mp5wD"};